










import Vue from 'vue';

export default Vue.extend({
  name: 'SearchPlaceholderBar',
  data() {
    return {};
  },
  props: {
    placeholder: {
      type: String,
      default: '请输入'
    },
    align: {
      type: String,
      default: 'left'
    }
  },
  watch: {},
  methods: {}
});
